module.exports = __webpack_public_path__ + "img/shibie1.3e92c846.png";